import agent from "../api/agent";

export interface Orders {
  id: number;
  unique_id: string;
  created_at: string;
  statusName?: string;
  statusHistory?: {
    status?: {
      id: number;
      name: string;
    };
  }[];
  items?: {
    price: number;
    quantity: number;
  }[];
  customer?: {
    mobile: string;
  };
  total_amount?: number;
  org?: {
    name: string;
  };
  outlet?: {
    name: string;
  };
}

export interface Order {
  id: number;
  unique_id: string;
  total_amount: string;
  created_at: string;
  user: {
    name: string;
    email: string;
    mobile: string;
  };
  items: {
    product_id: number;
    quantity: number;
    price: string;
    total: string;
    product: {
      name: string;
      sku: string;
      packaging_type: string;
      base_unit: string;
      base_mrp: string;
      quantity: string;
    };
  }[];
}

export interface OrderData {
  id: number;
  unique_id: string;
  total_amount: number;
  total_tax_amount:number;
  total_amount_with_tax:number;
  created_at: string;
  user: {
    name: string;
    email: string;
    mobile: string;
  };
  org: {
    name: string;
    legalname: string;
    mobile: string;
  };
  outlet: {
    name: string;
    email: string;
    mobile: string;
    shipping_addressline1: string;
    shipping_addressline2: string;
    shippingcity: string;
    shippingpincode: string;
    billing_addressline1: string;
    billing_addressline2: string;
    billingcity: string;
    billingpincode: string;
  };
  salesReturns: 
    {
      id: number;
      notes: string;
      //history:{
        //id:number,
       // total_quantity:string,
        items: [
        {
          id: number;
          quantity: number;
          product_id: number;
          reason:{
            name:string
          }
        }
      ];
      //}
      
    };
  statusHistory: {
    id: number;
    status: {
      id: string;
      name: string;
    };
    created_at: string;
  }[];
  items: {
    product_id: number;
    quantity: number;
    updated_quantity:number;
    final_quantity:number;
    price: string;
    total: number;
    tax_percent:string;
    tax_value:number;
    total_with_tax:number;
    product: {
      name: string;
      sku: string;
      packaging_type: string;
      unit: string;
      base_mrp: string;
      quantity: string;
      tax:string
    };
    // updatedQuantity: [
    //   {
    //     quantity: number;
    //   }
    // ];
  }[];
}

export interface SelectedProduct {
  product_id: number;
  name: string;
  quantity: number;
}

export interface Reason {
  id: number;
  name: string;
}

export interface SalesReturnFilters {
  startDate?: string;
  endDate?: string;
  statusId?: number | "";
  orderId?: string;
  stateId?: number | "";
}

export interface CNFilters {
  startDate?: string;
  endDate?: string;
  statusId?: number | "";
  orderId?: string;
  stateId?: number | "";
}

export const fetchOrders = async (filters?: {
  startDate?: string;
  endDate?: string;
  statusId?: number | "" | null;
  orderId?: string;
  orgId?: number | "" | null;
  outletId?: number | "" | null;
}): Promise<any> => {
  const payload: any = {
    start_date: filters?.startDate || "",
    end_date: filters?.endDate || "",
    orderId: filters?.orderId || "",
  };

  if (typeof filters?.statusId === "number" && !isNaN(filters.statusId)) {
    payload.status_id = filters.statusId;
  }

  if (typeof filters?.orgId === "number" && !isNaN(filters.orgId)) {
    payload.org_id = filters.orgId;
  }

  if (typeof filters?.outletId === "number" && !isNaN(filters.outletId)) {
    payload.outlet_id = filters.outletId;
  }

  const response = await agent.Orders.get(payload);
  return response;
};

export const fetchOrdersStatus = async (): Promise<any> => {
  const response = await agent.Orders.getstatus();
  return response;
};

export const getOrdersById = async (id: number): Promise<any> => {
  const response = await agent.Orders.getById(id);
  return response;
};
export const getPODById = async (id: number): Promise<any> => {
  const response = await agent.Orders.getPODById(id);
  return response;
};

// export const getOrdersById = async (id:number) => {
//   const result = await agent.Orders.getById(id);
//   return result;
// };

export const deleteOrders = async (id: number): Promise<any> => {
  const response = await agent.Orders.delete(id);
  return response.data;
};

export const addOrders = async (formData: FormData): Promise<any> => {
  const response = await agent.Orders.create(formData);
  return response;
};

export const updateOrders = async (formData: FormData): Promise<any> => {
  const response = await agent.Orders.update(formData);
  return response;
};

export const updateOrderStatus = async (
  order_id: string,
  status_id: number
): Promise<any> => {
  return await agent.Orders.changeStatus({ order_id, status_id });
};

export const updatequantity = async (payload: {
  order_id: number;
  product_id: number;
  quantity: number;
}): Promise<any> => {
  const response = await agent.Orders.updatequantity(payload);
  return response;
};

export const getSalesReturnReason = async (): Promise<any> => {
  const response = await agent.Orders.getSalesReturnReason();
  return response;
};

export const createSalesReturn = async (data: any): Promise<any> => {
  const response = await agent.Orders.createSalesReturn(data);
  return response;
};

export const fetchSalesReturn = async (
  filters?: SalesReturnFilters
): Promise<any> => {
  const params: Record<string, string> = {};

  if (filters?.startDate) params.start_date = filters.startDate;
  if (filters?.endDate) params.end_date = filters.endDate;
  if (filters?.statusId !== "" && filters?.statusId !== undefined)
    params.status_id = filters.statusId.toString();
  if (filters?.orderId) params.order_id = filters.orderId;
  if (filters?.stateId !== "" && filters?.stateId !== undefined)
    params.state_id = filters.stateId.toString();

  const response = await agent.Orders.getSalesReturn({ params });
  return response;
};
export const fetchPOD = async (filters?: SalesReturnFilters): Promise<any> => {
  const params: Record<string, string> = {};

  if (filters?.startDate) params.start_date = filters.startDate;
  if (filters?.endDate) params.end_date = filters.endDate;
  if (filters?.statusId !== "" && filters?.statusId !== undefined)
    params.status_id = filters.statusId.toString();
  if (filters?.orderId) params.order_id = filters.orderId;
  if (filters?.stateId !== "" && filters?.stateId !== undefined)
    params.state_id = filters.stateId.toString();

  const response = await agent.Orders.getPOD({ params });
  return response;
};
export const createCreditNote = async (data: any): Promise<any> => {
  const response = await agent.Orders.createCreditNote(data);
  return response;
};

export const fetchCN = async (filters?: CNFilters): Promise<any> => {
  const params: Record<string, string> = {};

  if (filters?.startDate) params.start_date = filters.startDate;
  if (filters?.endDate) params.end_date = filters.endDate;
  if (filters?.statusId !== "" && filters?.statusId !== undefined)
    params.status_id = filters.statusId.toString();
  if (filters?.orderId) params.order_id = filters.orderId;
  if (filters?.stateId !== "" && filters?.stateId !== undefined)
    params.state_id = filters.stateId.toString();

  const response = await agent.Orders.getCN({ params });
  return response;
};
